<template>
  <div :class="[
    'sidebar-area position-fixed start-0 top-0 bg-black h-100vh transition',
    { active: sidebarStoreInstance.open },
  ]" id="sidebar-area">
    <div class="logo position-absolute start-0 end-0 top-0 transition">
      <router-link to="/" class="d-flex align-items-center text-white text-decoration-none">
        <img :src="getEnvAsset('/images/logo.svg')" alt="logo-icon" class="img-fluid h-20" />
      </router-link>
      <div class="border-bottom"></div>
      <button class="sidebar-burger-menu position-absolute lh-1 bg-transparent p-0 border-0"
        @click="sidebarStoreInstance.onChange">
        <i class="ph-duotone ph-caret-double-right"></i>
      </button>
    </div>
    <div class="sidebar-menu transition">
      <ul class="sidebar-navbar-nav ps-0 mb-0 list-unstyled accordion" id="sidebarNavAccordion">
        <!-- PATIENTS -->
        <li class="sidebar-nav-item">
          <router-link to="/" class="sidebar-nav-link d-block">
            <i class="ph ph-house"></i>
            <span class="title">{{ $t('page.home') }}</span>
          </router-link>
        </li>
        <!-- PATIENTS -->
        <li class="sidebar-nav-item" v-if="indexEnabled">
          <router-link to="/patients" class="sidebar-nav-link d-block">
            <i class="ph ph-user"></i>
            <span class="title">{{ $t('page.patients') }}</span>
          </router-link>
        </li>
        <!-- MESSAGES -->
        <!-- <li class="sidebar-nav-item" v-if="config.feature.messages && indexEnabled">
          <router-link to="/messages" class="sidebar-nav-link d-block">
            <i class="ph ph-chat-circle"></i>
            <span class="title">{{ $t('page.messages') }}</span>
          </router-link>
        </li> -->
        <template v-if="isAdmin || isInternal">
          <!-- SYSTEM USERS -->
          <li class="sidebar-nav-item" v-if="isAdmin">
            <router-link to="/system-users" class="sidebar-nav-link d-block">
              <i class="ph ph-users-four"></i>
              <span class="title">{{ $t('page.system_users') }}</span>
            </router-link>
          </li>
          <!-- INVITATIONS -->
          <li class="sidebar-nav-item" v-if="isInternal && assignment_strategy === 'by_hcp'">
            <router-link to="/invite-user" class="sidebar-nav-link d-block">
              <i class="ph ph-user-plus"></i>
              <span class="title">{{ $t('page.invite_user') }}</span>
            </router-link>
          </li>
          <!-- HCP LIST -->
          <li class="sidebar-nav-item" v-if="isInternal && assignment_strategy === 'by_hcp'">
            <router-link to="/zone-hcp-list" class="sidebar-nav-link d-block">
              <i class="ph ph-users"></i>
              <span class="title">{{ $t('page.users') }}</span>
            </router-link>
          </li>
          <!-- CENTERS -->
          <li class="sidebar-nav-item" v-if="isAdmin || assignment_strategy === 'by_center'">
            <router-link to="/system-centers" class="sidebar-nav-link d-block">
              <i class="ph ph-buildings"></i>
              <span class="title">{{ $t('page.centers') }}</span>
            </router-link>
          </li>
          <!-- ROLES -->
          <li class="sidebar-nav-item" v-if="isAdmin">
            <router-link to="/system-roles" class="sidebar-nav-link d-block">
              <i class="ph ph-user-circle-gear"></i>
              <span class="title">{{ $t('page.roles') }}</span>
            </router-link>
          </li>
          <!-- SURVEYS -->
          <li class="sidebar-nav-item" v-if="isAdmin && config.feature.surveys">
            <router-link to="/surveys" class="sidebar-nav-link d-block">
              <i class="ph ph-question"></i>
              <span class="title">{{ $t('page.surveys') }}</span>
            </router-link>
          </li>
          <!-- CONSENTS -->
          <li class="sidebar-nav-item" v-if="(isAdmin || isInternal) && config.feature.consents">
            <router-link to="/consents" class="sidebar-nav-link d-block">
              <i class="ph ph-list-checks"></i>
              <span class="title">{{ $t('page.consents') }}</span>
            </router-link>
          </li>
          <!-- CONSENTS -->
          <li class="sidebar-nav-item" v-if="isAdmin">
            <router-link to="/zones" class="sidebar-nav-link d-block">
              <i class="ph ph-globe-simple"></i>
              <span class="title">{{ $t('page.zones') }}</span>
            </router-link>
          </li>
        </template>

        <!-- CONTENT LIBRARY -->
        <li class="sidebar-nav-item" v-if="isContentManager">
          <router-link to="/contents" class="sidebar-nav-link d-block">
            <i class="ph ph-book-open-text"></i>
            <span class="title">{{ $t('page.contents') }}</span>
          </router-link>
        </li>

        <!-- LOGOUT -->
        <li class="sidebar-nav-item">
          <router-link to="/logout" class="sidebar-nav-link d-block">
            <i class="ph ph-sign-out"></i>
            <span class="title">{{ $t('cta.logout') }}</span>
          </router-link>
        </li>


      </ul>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, provide } from "vue";
import sidebarStore from "../../utils/sidebar.store";
import stateStore from "../../utils/store";
import getEnvAsset from "@/utils/methods/env_assets";
import CONFIG from "@/utils/const/config";
import { Role, UserInfo } from "@/utils/models/user.model";


export default defineComponent({
  name: "MainSidebar",
  setup() {
    const sidebarStoreInstance = sidebarStore;
    return {
      sidebarStoreInstance,
    };
  },
  computed: {
    config() { return CONFIG },
    isAdmin() { return stateStore.isAdmin() },
    isInternal() { return stateStore.user?.info.role.type === Role.internal },
    isContentManager() { return stateStore.isContentManager() },
    indexEnabled(): boolean { return (stateStore.getPermisison('index') ?? false) || stateStore.user?.info.invitation_id !== null },
    assignment_strategy(): UserInfo['assignment_strategy'] { return stateStore.user?.info.assignment_strategy ?? 'by_center'}
  },
  methods: {
    getEnvAsset: getEnvAsset
  }

});
</script>